import React from 'react';
import Header from '../components/layout/Header';
import BottomNavBar from '../components/layout/BottomNav';
import CycleComponent from '../components/femaleCycle/Cycle';

const CyclePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-base-200">
      <Header />
      <CycleComponent />
      <BottomNavBar />
    </div>
  );
};

export default CyclePage;

